import { Skeleton } from "antd";
import { useEffect, useState } from "react";
import styles from "./Dashboard.module.css";

export const RoomOverview = ({ data, loading }) => {
  const { rooms, roomPrices } = data || {};
  const [roomsData, setRoomsData] = useState([]);
  const isLoading = loading?.rooms || loading?.roomPrices;

  useEffect(() => {
    calculateRoomPrices();
  }, [rooms, roomPrices]);

  const calculateRoomPrices = async () => {
    try {
      const updatedRoomsData = rooms
        ?.filter((room) => room?.room_type.name !== "FOC")
        ?.map((room) => {
          const roomPrice = roomPrices?.find((price) => price.room === room.id);
          return {
            type: room.room_type.name,
            available: room.status === "available" ? 1 : 0,
            total: 1,
            price: roomPrice ? roomPrice.amount : "N/A",
          };
        });

      // Deduplicate by room type (keep only first occurrence)
      const uniqueRoomTypes = updatedRoomsData?.reduce((acc, current) => {
        if (!acc.some((room) => room.type === current.type)) {
          acc.push(current);
        }
        return acc;
      }, []);

      setRoomsData(uniqueRoomTypes);
    } catch (error) {
      console.error("Error fetching room data:", error);
    }
  };

  return (
    <section className={styles.roomOverview} aria-label="Room Overview">
      <h2 className={styles.sectionTitle}>Room Rates</h2>

      <div className={styles.roomGrid}>
        {isLoading ? (
          <>
            {Array.from({ length: 4 }).map((_, index) => (
              <div key={index} className={styles.roomCard}>
                <Skeleton
                  active
                  title={{ width: "50%" }}
                  paragraph={{
                    rows: 2,
                    width: ["40%", "30%"],
                  }}
                />
              </div>
            ))}
          </>
        ) : (
          <>
            {roomsData?.map((room, index) => (
              <div key={index} className={styles.roomCard}>
                <div className={styles.roomType}>
                  {room.type.charAt(0).toUpperCase() + room.type.slice(1)}
                </div>

                <div className={styles.roomPriceContainer}>
                  <div className={styles.priceAmount}>&#8377;{room.price}</div>
                  <div className={styles.priceUnit}>/ day</div>
                </div>
              </div>
            ))}
          </>
        )}
      </div>
    </section>
  );
};
